import VEHICLE_TYPE from '../../types/vehicle-types';
import SEARCH_RESULT_TYPE from '../../types/search-result-types';

export const MIXED_ROUTE_RESULTS_NOTE = 'Results cover every route with that public number.';

export const getRouteModeName = routeType => VEHICLE_TYPE[routeType]?.type || '';

export const getRoutePrimaryLabel = (route = {}) => route.route_short_name || route.routeShortName || '';

export const getRouteId = (route = {}) => route.route_id || route.routeId || '';

export const getRouteType = (route = {}) => route.route_type ?? route.routeType;

export const getRouteSecondaryLabel = (route = {}) => {
    const mode = getRouteModeName(getRouteType(route));
    const routeId = getRouteId(route);
    if (!routeId) {
        return mode;
    }
    return mode ? `${mode} · ${routeId}` : routeId;
};

export const formatRouteLabelInline = (route) => {
    const primary = getRoutePrimaryLabel(route);
    const secondary = getRouteSecondaryLabel(route);
    if (!secondary) {
        return primary;
    }
    return primary ? `${primary} (${secondary})` : secondary;
};

export const getSearchSelectionDisplayValue = (entity, useRouteSearchByRouteId) => {
    if (!entity) {
        return '';
    }
    if (useRouteSearchByRouteId && entity.category?.type === SEARCH_RESULT_TYPE.ROUTE.type && entity.data) {
        return formatRouteLabelInline(entity.data);
    }
    return entity.text || '';
};

export const takeRoutesByDistinctPublicNumbers = (items, maxPublicNumbers) => {
    if (!Array.isArray(items)) {
        return items;
    }
    const seen = [];
    const result = [];
    items.forEach((item) => {
        const publicNumber = item.data?.route_short_name || item.text;
        if (!seen.includes(publicNumber)) {
            if (seen.length >= maxPublicNumbers) {
                return;
            }
            seen.push(publicNumber);
        }
        result.push(item);
    });
    return result;
};

export const areRouteResultsMixed = (requestedRouteId, routes = []) => {
    if (!requestedRouteId) {
        return true;
    }
    return routes.some(route => getRouteId(route) && getRouteId(route) !== requestedRouteId);
};
